<script setup>
    import { defineProps, defineEmits, computed } from 'vue';
    import { formatDate } from '../../mixins/visualFormatters';
    import { useStore } from 'vuex';

    const store = useStore()
    const userProfile = computed(() => store.getters['user/userProfile']);

    const inferCommentText = computed(() => {
        if(props.comment.text){
            return props.comment.text
        } else if(props.comment.comment){
            return props.comment.comment
        } else return ""
    })

    const inferCommentProfileImage = computed(() => {
        if(props.comment.user.picture){
            return props.comment.user.picture
        } else if(props.comment.user.profileImage){
            return props.comment.user.profileImage
        } else return ""
    })
    
    const postDateFormatted = computed(() => {
        if(props.comment.time){

        // If the comment.time is a date object, format it
        if (props.comment.time instanceof Date) {
            return formatDate(props.comment.time)
        } else {
            return formatDate(props.comment.time.toDate())
        }
    }
    else if (props.comment.date){
        if (props.comment.time instanceof Date) {
            return formatDate(props.comment.date)
        } else {
            return formatDate(props.comment.date.toDate())
        }

        
    } else return ""

    })

    const emits = defineEmits(['deleteComment'])

    const props = defineProps(["comment", "commentIndex"])

    const emitCommentDelete = () => {
        const deleteConfirmation = confirm("Bu yorumu silmek istediğinize emin misiniz?")
        const commentIndex = props.commentIndex
        if (deleteConfirmation) {
            emits('deleteComment', commentIndex)
        }
    }

</script>

<template>
    <div :data-comment-index="commentIndex" class="comment-area">
        <div class="comment-header">
            <div class="comment-user">
                <span v-if="comment.user.profileImage === 'ai-message'" class="image-container">
                    <img class="animated" src="../../assets/icons/ai.png">
                </span>
                <img v-else referrerpolicy="no-referrer" class="comment-profile-image" :src="inferCommentProfileImage" alt="user picture">
                <span>{{ comment.user.name }}</span>
            </div>
            <div class="comment-date">
                {{ postDateFormatted }}
            </div>

            <div @click="emitCommentDelete()" v-if="userProfile.name === comment.user.name" class="comment-deleter ml-auto opacity-40 hover:scale-120 cursor-pointer " >
                <img reffererpolicy="no-referrer" width="14" :src="require('../../assets/icons/delete-grayscale.png')" alt="">
            </div>


        </div>
        <div class="comment-body">
            {{ inferCommentText }}
        </div>
    </div>
</template>

<style scoped lang="scss">

@import "../../styles/global/helpers.scss";

.comment-area{
    border: 1px solid rgba(0,0,0,.1);
    padding: 1.2rem 1.6rem;
    border-radius: 8px;
    margin-bottom: 1.6rem;
}

.comment-header{
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    justify-content: space-between;
}

.comment-user{
    display: flex;
    align-items: center;
    gap: .4rem;
    font-size: 1.4rem;
    font-weight: 600;;
    margin-right: 1.6rem;
}

.comment-date{
    color: #8a8a8a;
    font-size: 1.4rem;
}

.comment-body{
    white-space: pre-wrap;
    font-size:1.5rem;
    line-height: 145%;
}

span.image-container {
    width: 3.6rem;
    height: 3.6rem;;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border-radius: 50%;
    position: relative;
    background-image: linear-gradient(to right, #000435, #000273);
}

span.image-container img {
    width: 2.4rem;
    height: 2.4rem;
    filter: brightness(0) invert(1);
}

.animated {
    animation: pulse 1s infinite alternate;
}

@keyframes pulse {
    0% {
        opacity: 60%;
    }

    100% {
        opacity: 100%;
    }
}

</style>